import { render, staticRenderFns } from "./perception.vue?vue&type=template&id=6ab7c766&scoped=true&"
import script from "./perception.vue?vue&type=script&lang=js&"
export * from "./perception.vue?vue&type=script&lang=js&"
import style0 from "./perception.vue?vue&type=style&index=0&id=6ab7c766&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab7c766",
  null
  
)

export default component.exports